import { useRouteBodyRef } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";

/**
 * Whether the learner has pressed a wrong tone on this card. Wrong tones don't reveal, so the
 * eventual correct answer presets Again instead of Easy.
 */
export function useHasMissedPronunciationToneRef() {
  return useRouteBodyRef("pronunciation-tone-missed", false);
}
